import { render, staticRenderFns } from "./SettingsDashboard.vue?vue&type=template&id=5f7dd47d&"
import script from "./SettingsDashboard.vue?vue&type=script&lang=js&"
export * from "./SettingsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports